import { PayrollSummaryImportButtonDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const usePayrollSummaryImportButton = () => {
  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()

  const { data, loading } = useQuery(PayrollSummaryImportButtonDocument, {
    variables: {
      companyId: currentCompanyId,
    },
  })

  const policy = data?.payroll.policiesConnection.nodes?.[0]
  const permissions = data?.payroll._policies.resultsSeeCompanyPayrollResults.can
  const nodes = data?.payroll.policiesConnection.nodes

  const canSeeButton = !!policy && !!permissions

  return {
    policy,
    permissions,
    nodes,
    loading,
    canSeeButton,
  }
}
